import { updateCaseDetailsApi } from 'Constants';
import { Context } from 'Context/Context';
import React, { useContext, useEffect, useState } from 'react'

function AdditionalInfoEdit({
    id,
    setUpdateComp,
    text,
    isCaseOpen
}) {

    const [showEdit, setShowEdit] = useState();
    const {makeApiCallFunc} = useContext(Context);

    useEffect(() => {
        const isText = ( typeof text !== "undefined");
        setShowEdit(text);
        console.log(isText);
    }, [text]);

    const [updatedText, setUpdatedText] = useState(text);

    const updateExtraData = () => {
        makeApiCallFunc(
            updateCaseDetailsApi+"/"+id,
            {
                "additionalNotes" : updatedText
            },
            null,
            ({data}) => {
                setUpdateComp(prev => !prev)
                //setUpdatedText(data?.additionalNotes ? data?.additionalNotes : "");
                 //setMoreText(true);
                //window.scrollTo(0,500);
            },
            (data) => console.log(data),
        )
    }
  return (
    <div className='flex flex-col font-plexsans'>
        {isCaseOpen && <div className='text-[13px] font-semibold text-navy mb-2'>More information on the issue (text limit 500)</div>}
        {
        !showEdit ?
        <div className='flex items-baseline'>
            <div className='mr-1 text-[13px] text-navy'>{updatedText}</div>
            {isCaseOpen && <div
            className='text-tan hover:text-tanDark ml-2 text-[12px] font-medium'
            onClick={() => setShowEdit(true)}>edit</div>}
        </div>
        :
        (isCaseOpen &&
        <div>
            <textarea
            value = {updatedText}
            onChange={(e) => setUpdatedText(e.target.value)}
            className='border border-[rgba(20,33,61,.15)] rounded-lg p-2.5 w-full focus:ring-tan focus:border-tan focus:outline-none text-[13px] mb-2.5'
            placeholder='Tell us more about the issue (Optional)'
            rows="5"
            >
            </textarea>
            <div className='text-[13px] font-semibold bg-tan hover:bg-tanDark text-white cursor-pointer p-2 rounded-lg px-3 w-max' onClick={updateExtraData}>Update</div>
        </div>)
        }
    </div>
  )
}

export default AdditionalInfoEdit
